import gql from 'graphql-tag';

export default gql`
  query brokerPhoneAvailableNumberQuery($areaCode: String, $zipCode: String) {
    brokerPhoneAvailableNumber(areaCode: $areaCode, zipCode: $zipCode)
  }
`;
